import React, { useCallback, useMemo } from "react";
import { useAppDispatch } from "../../../../../state/store";
import { setPageAction } from "../../../../../state/usecase/admin/care_recipient/actions";
import useAlerts from "../../../../hooks/admin/care_recipient/useAlerts";
import { Paginate } from "../../../common/button/paginate/Paginate";

export const AlertsPager = React.memo(function AlertsPager(props: { maxShowAlertCount: number }) {
    const dispatch = useAppDispatch();

    const { alerts, displayAlertsPage } = useAlerts();

    const { maxShowAlertCount } = props;

    const pageCount = useMemo(() => alerts ? Math.ceil(alerts.length / maxShowAlertCount) : 1, [alerts, maxShowAlertCount]);

    const onPageChange = useCallback((page: number) => {
        dispatch(
            setPageAction({ page: page })
        );
    }, [dispatch]);

    return (
        <div className={"paging_area"}>
            <Paginate pageCount={pageCount} onPageChange={onPageChange} currentPage={displayAlertsPage} />
        </div>
    );
});